import flatten from 'lodash/flatten';

export const period = '2023-03-06';
export const periods = [period];

export const enabledDishes = {
    main: [
        '3214',
        '3009',
        '25',
        '3702',
    ],
    appetizer: [
        '3926',
        '3921',
        '3947',
        '3948',
        '3723',
        '364',
        '3386',
        '2561',
    ],
    dessert: [
        '3835',
        '3843',
    ],
};

export const availableBasketDishIds = flatten(Object.values(enabledDishes));
